export const absurd = <A>(x: never): A => {
  throw new Error('Should not be here');
};
